import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import React from "react";
import PopoverPositionProvider from "@/components/providers/PopoverPositionProvider";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { NavigationMenuProps } from "../types";
import NavigationMenuViewport from "./navigation-menu-viewport";

function NavigationMenu({
  viewport = true,
  className,
  children,
  ...props
}: NavigationMenuProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <PopoverPositionProvider>
      <NavigationMenuPrimitive.Root
        data-slot="navigation-menu"
        data-viewport={viewport}
        className={cn(
          "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
          className,
          classes,
        )}
        {...native}
      >
        {children}
        {viewport && <NavigationMenuViewport />}
      </NavigationMenuPrimitive.Root>
    </PopoverPositionProvider>
  );
}

NavigationMenu.displayName = "NavigationMenu";

export default NavigationMenu;
